import {
  AppointmentTypeEnum,
  GetAppointmentOutput,
} from '../graphql/generated/hasura';
import {
  MY_APPOINTMENTS_CHAT_CONSULTATION,
  MY_APPOINTMENTS_VIDEO_CONSULTATION,
} from './routes';
import { CalendarEvent } from 'calendar-link';
import { UpcomingAppoinment } from '../app/my-appointments/interfaces';

export const generateMeetLink = (appointment: {
  appointmentType?: AppointmentTypeEnum | null;
  appointmentId?: string | number;
}): string => {
  const domain = window.location.origin;

  const baseServiceLink =
    appointment?.appointmentType === AppointmentTypeEnum.Chat
      ? MY_APPOINTMENTS_CHAT_CONSULTATION
      : MY_APPOINTMENTS_VIDEO_CONSULTATION;

  return `${domain}${baseServiceLink}&appointment-id=${appointment?.appointmentId}`;
};

type CalendarType = Pick<
  UpcomingAppoinment,
  'date' | 'end' | 'name' | 'appointmentType' | 'appointmentId'
>;

export const mapUpcomingAppointmentToCalendarParams = (
  appointment?: CalendarType | null,
  isProvider?: boolean,
) => {
  if (!appointment) return null;

  const start = new Date(appointment?.date);
  const end = new Date(appointment?.end);

  const startISO = start.toISOString();
  const endISO = end.toISOString();

  const meetLink = generateMeetLink(appointment);

  // TEXT for event body
  const description = `
Appointment with ${appointment?.name}
Join meeting: ${meetLink}
`.trim();

  const event: CalendarEvent = {
    title: `Appointment with your ${isProvider ? 'patient' : 'provider'}`,
    description,
    start: startISO,
    end: endISO,
    location: meetLink,
  };

  return event;
};

export const mapUpcomingDnaAppointmentToCalendarParams = (
  appointment?: UpcomingAppoinment | null,
) => {
  if (!appointment) return null;

  const start = new Date(appointment?.date);
  const end = new Date(appointment?.end);

  const startISO = start.toISOString();
  const endISO = end.toISOString();

  const meetLink = appointment.appointmentUrl;

  // TEXT for event body
  const description = `
Appointment with ${appointment?.name}
Join meeting: ${meetLink}
`.trim();

  const event: CalendarEvent = {
    title: 'Appointment with DNA provider',
    description,
    start: startISO,
    end: endISO,
    location: meetLink,
  };

  return event;
};

type GetAppointmentStatuses = Omit<GetAppointmentOutput, 'recommendations'>;

export const mapGetAppointmentOutputToCalendarParams = (
  appointment?: GetAppointmentStatuses | null,
  isProvider?: boolean,
): CalendarEvent | null => {
  if (!appointment) return null;

  const startISO = appointment.start ?? '';
  const endISO = appointment.end ?? '';

  const startDate = new Date(startISO);
  const endDate = new Date(endISO);

  const start = startDate.toISOString();
  const end = endDate.toISOString();

  const patientName = `${appointment.patientFirstName ?? ''} ${
    appointment.patientLastName ?? ''
  }`.trim();
  const providerName = `${appointment.providerFirstName ?? ''} ${
    appointment.providerLastName ?? ''
  }`.trim();

  const meetLink = generateMeetLink(appointment);

  const description = `
DECODE.ME: Appointment with ${isProvider ? patientName : providerName}
Join meeting: ${meetLink}
`.trim();

  return {
    title: `DECODE.ME: Appointment with your ${
      isProvider ? 'patient' : 'provider'
    }`,
    start,
    end,
    description,
    location: meetLink,
  };
};
